<template>
	<div>
		<vue-headful
            :title="$gstate.getTitle()"
        />
		<div id="app" v-if="showPage">
			<cc-header v-if="showHeaderFooter"></cc-header>

			<main role="main" v-bind:class="{ 'container' : showHeaderFooter }">
				<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
					<cc-rate-hold-timer @finished="rateHoldTimerFinished" v-if="showRateHoldTimer"></cc-rate-hold-timer>
				</transition>
				<transition name="router-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
					<router-view @reset="reset" @setRateHoldTimer="setRateHoldTimer" @setLeaveNotification="setLeaveNotification"></router-view>
				</transition>
			</main>

			<cc-quote-expired v-if="showModal" @closeExpiredQuoteModal="closeExpiredQuoteModal" />
			
			<cc-modal v-if="showBrowserModal" @action="browserModalAction" close="Back">
				<p slot="body">Unfortunately your browser isn't supported.  We recommend updating to the latest versions of Chrome, Safari, or Firefox.</p>
			</cc-modal>

			<cc-footer v-if="showHeaderFooter" />

			<template v-if="$gstate.isDev() && showHeaderFooter">
			browser info: {{ browserObj.name }}, {{ browserObj.version }}, {{ browserObj.os }}
			</template>
			
		</div>
	</div>

</template>

<script>

	import { eventBus } from './main'

	require('./assets/css/bootstrap.min.css');
	require('./assets/css/animate.css');
	require('./assets/css/style.css');
	

	export default {
		name: "app",
		data() {
			return {
				showModal: false,
				showHeaderFooter: true,
				showRateHoldTimer: false,
				showPage: false,
				showBrowserModal: false,
				browserObj: {}
			};
		},
		created(){
			eventBus.$on('paramHandlerFail', this.paramHandlerFail);
			eventBus.$on('logGTMTransactionEvent', this.logGTMTransactionEvent);
			eventBus.$on('showHeaderFooterEvent', this.showHeaderFooterEvent);

			this.browserDetection();

			if(this.$route.name == "transaction-pro" || this.$route.name == "verify-pro"){
				this.$gstate.setProFlow(true);
			}

			// update favicon
			var favicon = document.getElementById("favicon");
			favicon.href = "/static/img/merchant/" + this.$gstate.getMerchant().toLowerCase() + "/favicon.png";

			// load merchant css if not coincurve.
			// if it's pro flow, then load merchant CSS because that's how we override the normal coincurve css
			if(this.$gstate.isCoincurve() && !this.$gstate.isProFlow()){
				this.showPage = true;
			} else {
				this.loadMerchantCSS();
			}

			// eslint-disable-next-line
			console.info(this.$gstate.getVersion());
			
		},
		beforeDestroy(){
			eventBus.$off('paramHandlerFail', this.paramHandlerFail);
			eventBus.$off('logGTMTransactionEvent', this.logGTMTransactionEvent);
			eventBus.$off('showHeaderFooterEvent', this.showHeaderFooterEvent);
		},
		mounted() {

			// reset state when mounted
			if(this.$route.name == "credit-card-quote"){
				return;
			}
			
			this.reset(false);			

			// allow these paths to be hit directly
			if (
				this.$route.name == "transaction" || 
				this.$route.name == "transaction-type" || 
				this.$route.name == "transaction-type-currency" || 
				this.$route.name == "transaction-type-currency-subtype" ||
				this.$route.name == "transaction-pro" || 
				this.$route.name == "transaction-new" ||
				this.$route.name == "proc-handler" ||
				this.$route.name == "cash-in-locations" ||
				this.$route.name == "buyer-info-input" ||
				this.$route.name == "credit-card-quote" ||
				this.$route.name == "verify-idenfy" ||
				this.$route.name == "state"
				) {
				// normal path
			} else if (this.$route.name == "privacy-policy" || this.$route.name == "terms-of-service" || this.$route.name == "compliance-policy" || this.$route.name == "refund-policy") {
				// allow to navigate directly to legal pages
			} else if (this.$route.name == "verify" || this.$route.name == "verify-pro") {
				// allow to navigate to upload page
			} else {

				// fail and redirect home unless debugging (then go ahead and uncomment stuff)
				this.$router.push("/");
				//this.$router.push('/price-quote');
				//this.$router.push('/address-input');
				//this.$router.push('/buyer-info-input');
				//this.$router.push('/mobile-verification');
				//this.$router.push('/audio-input');
				//this.$router.push('/audio-delete');
				//this.$router.push('/payment-etransfer');
				//this.$router.push('/payment-etransfer-success');
				//this.$router.push('/payment-flexepin');
				//this.$router.push('/payment-flexepin-success');
				//this.$router.push('/payment-otc');
				//this.$router.push('/payment-otc-success');
				//this.$router.push('/payment-spend');
				//this.$router.push('/payment-spend-success');
			}

		},
		methods: {
			loadMerchantCSS(){

				// load in external css
				var urlstr = "static/css/style_merchant_"+ this.$gstate.getMerchant().toLowerCase() +".css";
				this.axios.get(urlstr)
				.then(response => {
					var style = document.createElement('style');
					style.type = 'text/css';
					style.innerHTML = response.data;
					document.getElementsByTagName('head')[0].appendChild(style);

					this.showPage = true;
				})
				// eslint-disable-next-line
				.catch(error => {
					this.loadMerchantCSS();
				});
				
			},
			rateHoldTimerFinished(){
				
				// show modal when rate hold expires
				this.showModal = true;

			},
			closeExpiredQuoteModal(){
				
				this.showModal = false;

			},
			reset(doRedirect = true){
				// close modal if user clicks button
				this.showModal = false;

				// close the rate hold timer box
				this.showRateHoldTimer = false;

				// reset the state of the quote
				this.$gstate.init();

				// redirect back to home screen
				if(doRedirect){
					this.$router.push("/");
				}
			},
			setRateHoldTimer(data){
				this.showRateHoldTimer = data;
			},
			setLeaveNotification(data){
				if(data){
					this.$root.EnableLeaveNotification();
				} else {
					this.$root.DisableLeaveNotification();
				}
			},
			paramHandlerFail(){
				this.showPage = false;
			},
			logGTMTransactionEvent(eventName){

				if(this.$gstate.isProd()){
					
					this.$gtm.trackEvent({
						'event': eventName,
						'ecommerce':{
							'purchase': {
								'actionField' : {
									'id': this.$gstate.getRefId(),
									'affiliation': this.$gstate.getMerchantName(),
									'revenue': this.$gstate.getFlowState().fiatAmount,
									'tax': 0,
									'shipping': 0,
								},
								'products': [{
									'id': this.$gstate.getPaymentMethod(),
									'name': this.$gstate.getPaymentMethod().toLowerCase(),
									'category': 'BUY',
									'price': this.$gstate.getFlowState().fiatAmount,
									'quantity': 1
								}]
							}
						}
					});
				}

			},
			browserDetection(){
				const { detect } = require('detect-browser');
				const browser = detect();

				//const browser = this.$browser.detect();
				if(browser){
					
					this.browserObj.name = browser.name;
					this.browserObj.version = browser.version;
					this.browserObj.os = browser.os;

				} else {
					this.browserObj.name = 'No browser information available.';
				}

			},
			browserModalAction(){
				this.setLeaveNotification(false);
				this.$gstate.redirectHome('', 0, 'browserModalAction');
			},
			showHeaderFooterEvent(value){
				this.showHeaderFooter = value;
			}
		}
	};
</script>